import React, {useEffect, useState} from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

const ProfileMenu = (props) => {
    const location = useLocation();

    const [Time, setTime] = useState('')

    useEffect(() => {
        let timeOfDay;
        const date = new Date();
        const hours = date.getHours();

        if (hours < 10) {
            timeOfDay = 'Morning';
          } else if (hours >= 10 && hours < 18) {
            timeOfDay = 'Afternoon';
          } else {
            timeOfDay = 'Night';
          }
        
        setTime(timeOfDay)
    }, [])

    const Path = [
        {
            name: 'Profile',
            path: '/profile'
        },
        {
            name: 'Company',
            path: '/company'
        },
        {
            name: 'Wishlists',
            path: '/wishlist'
        },
        {
            name: 'Order Request History',
            path: '/history'
        },
    ]


    return (
        <Container>
            <Row>
                <Col lg={12}>
                    <p className="m-0 fs-6 fst-italic">{"Good " + Time + "," }</p>
                    <p className="fs-3 fw-bold mb-4">{props.name}</p>
                    <div className="link-profile">
                        {
                            Path.map((item, i) => (
                                <Link key={i} to={item.path}
                                    className={item.path === location.pathname ? `btn btn-primary` : `btn btn-secondary`}>
                                    {item.name}
                                </Link>
                            ))
                        }
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default ProfileMenu
